import * as React from 'react';
export var StaticPage = function (_a) {
    var content = _a.content;
    // If the document's content hasn't been loaded yet, display a spinner.
    if (!content || !content.html || !content.meta) {
        return (React.createElement("section", { className: "docs-content" },
            React.createElement("div", { className: "auth0-spinner" },
                React.createElement("div", { className: "spinner" }))));
    }
    var classes = ['content'];
    if (content.meta)
        classes = classes.concat(content.meta.classes);
    return (React.createElement("section", { className: classes.join(' '), "data-swiftype-name": "body", "data-swiftype-type": "text", "data-swiftype-index": "true", dangerouslySetInnerHTML: { __html: content.html } }));
};
